module.exports = __webpack_public_path__ + "static/media/dashboard@2x.630a97fb.png";